import { render, staticRenderFns } from "./CreateDunningLetter.yaml?vue&type=template&id=033e81a0&component"
import script from "./CreateDunningLetter.yaml?vue&type=script&lang=ts&component"
export * from "./CreateDunningLetter.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports